<template>
  <div class="container">

    <div class="card-img-art">
      <img :src="url('/media/prodotti-gruppi/' + filename)" :alt="filename">
      <p>{{cod_articolo}}</p>
    </div>

  </div>
</template>

<script>
export default {
  name: "img-card",
  props: ['filename', 'cod_articolo'],
  data() {
    return {}
  },
  mounted() {
    this.parseFilename()
  },
  methods: {
    parseFilename:function () {
      this.filename = this.filename.replace(/\+/g, "%2B")
    //  console.log(this.filename)
    }
  },
}
</script>

<style lang="scss" scoped>
.container {
  .card-img-art {
    img {
      width: 50px;
    }
  }
}
</style>
